<template>
  <section id="thank-you">
    <div class="container">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <div align="center">
            <div class="succesful-circle">
              <i class="far fa-check-circle icon-succesful"></i>
            </div>
            <h2 class="page-title">
              {{$t("pendingOxxo.title")}}
            </h2>
            <p class="page-text">
              {{$t("pendingOxxo.message")}}
            </p>
            <div class="mt-40" align="center">
              <router-link to="/events">
                <button class="button-blue-success">
                  {{$t("pendingOxxo.events")}}
                </button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-md-1"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Checkout.PendingOxxo",
  data() {
    return {
      order: {}
    }
  },
  created() {
    if(this.$route == undefined || !this.$route.params.hasOwnProperty("order")) {
      this.$router.push({name: "Home"})
    } else {
      this.order = this.$route.params.order
      this.openModal()
    }
  },
  methods: {
    openModal() {
      stripe.confirmOxxoPayment(this.order.external_id, {
        payment_method: {
          billing_details: {
            name: this.order.full_name,
            email: this.order.email
          }
        }
      }).then(function(result) {
        if(result.error) {
          this.$alertify.error(result.error.message)
          alertify.error(result.error.message)
        }
      })
    }
  }
}
</script>

<style lang="scss">

</style>
